import React from 'react';

import { useStyletron } from 'baseui';
import { StyledTable, StyledHeadCell, StyledBodyCell } from 'baseui/table-grid';

import debug from 'utils/debug';

const { METHOD } = debug('c:ModalWindows:TableViewer');

export default function(props) {
  METHOD('Table', { props });

  const [css] = useStyletron();

  const { headers, content } = props;

  METHOD('Content', { headers, content });

  const gridTemplateColumns = headers
    .map(col => col.width || 'max-content')
    .join(' ');
  return (
    <div className={css({ height: 'calc(90vh - 210px)', width: 'auto' })}>
      {headers.length && (
        <StyledTable $gridTemplateColumns={gridTemplateColumns}>
          {headers.map((col, colIndex) => (
            <StyledHeadCell key={`head-cell-${colIndex}`}>
              {col.label || `Column ${colIndex}`}
            </StyledHeadCell>
          ))}
          {content.map((row, rowIndex) => {
            return (
              <React.Fragment key={`row-${rowIndex}`}>
                {row.map((value, colIndex) => (
                  <StyledBodyCell
                    $striped={rowIndex % 2 === 0}
                    key={`body-cell-${colIndex}-${rowIndex}`}
                  >
                    {value}
                  </StyledBodyCell>
                ))}
              </React.Fragment>
            );
          })}
        </StyledTable>
      )}
    </div>
  );
}
